import {PLAN_DATA} from "@/Enums/plans";
import PlanBlock from "@/Components/Blocks/PlanBlock";

export default function SettingsPlans({organization}) {

  return (
    <div className="flex flex-col md:flex-row items-start">
      { PLAN_DATA.map((plan, index) => <PlanBlock key={ index } plan={ plan } currentPlan={organization?.data?.plan} />) }
    </div>
  )
}

